export const SkeletonButton = () => (
  <div className="w-34 h-12 rounded-full bg-blue-200"></div>
);
